'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _disclosure = require('../disclosure.js');

var _disclosure2 = _interopRequireDefault(_disclosure);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _functional_utility = require('common-utilities/src/functional_utility');

var _string_utility = require('../../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility2 = require('../../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardComponent = function (_React$PureComponent) {
  _inherits(CardComponent, _React$PureComponent);

  function CardComponent(props) {
    _classCallCheck(this, CardComponent);

    var _this = _possibleConstructorReturn(this, (CardComponent.__proto__ || Object.getPrototypeOf(CardComponent)).call(this, props));

    _this.renderCardHeader = _this.renderCardHeader.bind(_this);
    return _this;
  }

  _createClass(CardComponent, [{
    key: 'renderCardHeader',
    value: function renderCardHeader() {
      if (this.props.hideHeader) {
        return null;
      }
      var headerClass = this.props.showToggleView ? " display-inline" : "";
      var headerLabelClass = 'padding-bottom-20 margin-horizontal--30 padding-horizontal-' + (this.props.is25PercentCard ? '24' : '30') + ' padding-top-10 border-bottom-1 border-card-title-border' + (this.props.noPadding || this.props.is25PercentCard ? "" : " margin-bottom-20");
      var headerLabelClassMobile = 'padding-bottom-16 margin-horizontal--16 border-bottom-1 border-card-title-border' + (this.props.noPadding || this.props.is25PercentCard ? "" : " margin-bottom-20");
      var HeaderTag = 'h' + (this.props.headerTagLevel || '2');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: '' + (!(this.props.breakpoint < 3) ? headerLabelClass : headerLabelClassMobile),
            'data-testid': 'headerDiv' },
          !(0, _ramda.isNil)(this.props.headerTitle) && _react2.default.createElement(
            HeaderTag,
            { id: this.props.headerTitleId,
              'data-testid': '' + this.props.headerTitleId,
              'data-header': '' + this.props.headerTitleLabel,
              className: (this.props.breakpoint < 3 ? 'padding-horizontal-16 sub-header-3' : 'sub-header-2') + ' ' + (this.props.noPadding ? 'padding-horizontal-10' : '') + headerClass },
            this.props.headerTitle,
            !(0, _ramda.isNil)(this.props.headerRightInline) && this.props.headerRightInline
          ),
          !(0, _ramda.isNil)(this.props.headerRight) && this.props.headerRight,
          this.props.showToggleView && !(0, _functional_utility2.isMobileBreakpoint)(this.props.breakpoint) && this.renderToggle(),
          !(0, _functional_utility.isNilOrEmpty)(this.props.headerLabel) && _react2.default.createElement(
            'div',
            null,
            this.props.headerLabel
          )
        ),
        this.props.showToggleView && (0, _functional_utility2.isMobileBreakpoint)(this.props.breakpoint) && this.renderToggle()
      );
    }
  }, {
    key: 'renderToggle',
    value: function renderToggle() {
      var _props = this.props,
          activeCardTitle = _props.activeCardTitle,
          inactiveCardTitle = _props.inactiveCardTitle,
          activeCardId = _props.activeCardId,
          inactiveCardId = _props.inactiveCardId,
          toggleAction = _props.toggleAction,
          toggleActionParameter = _props.toggleActionParameter,
          activeClass = _props.activeClass,
          inactiveClass = _props.inactiveClass;

      var containerClass = (0, _functional_utility2.isMobileBreakpoint)(this.props.breakpoint) ? "display-inline-flex padding-top-6 padding-bottom-22 width-percent-100" : "display-inline float-right padding-top-5";
      var toggleClass = (0, _functional_utility2.isMobileBreakpoint)(this.props.breakpoint) ? "freq-toggle text-center vertical-align-middle width-percent-50" : "freq-toggle";
      var inactiveTypography = (0, _functional_utility2.isMobileBreakpoint)(this.props.breakpoint) ? " body2" : " disclaimer";
      var activeTypography = (0, _functional_utility2.isMobileBreakpoint)(this.props.breakpoint) ? " body2" : " disclaimer2";

      var inactiveStyle = { cursor: 'pointer', color: '#096183', padding: '8px', background: '#F5F7F8', border: '1px solid #E2E4E5' };
      var inactiveCss = '';
      if (inactiveClass) {
        inactiveStyle = { cursor: 'pointer' };
        inactiveCss = inactiveCss + inactiveClass + inactiveTypography;
      } else {
        inactiveCss = toggleClass + inactiveTypography;
      }
      var activeStyle = { cursor: 'auto', color: 'black', padding: '8px', background: 'white', border: '1px solid #E2E4E5' };
      var activeCss = '';
      if (activeClass) {
        activeStyle = { cursor: 'auto', borderBottom: '1px solid', marginBottom: '1px' };
        activeCss = activeCss + activeClass + activeTypography;
      } else {
        activeCss = toggleClass + activeTypography;
      }

      return _react2.default.createElement(
        'div',
        { className: containerClass },
        _react2.default.createElement(
          'span',
          { id: activeCardId, className: activeCss, style: activeStyle },
          activeCardTitle
        ),
        _react2.default.createElement(
          'span',
          { id: inactiveCardId, className: inactiveCss, onClick: function onClick() {
              return toggleAction(toggleActionParameter);
            }, style: inactiveStyle },
          inactiveCardTitle
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var custPosition = (0, _ramda.isNil)(this.props.displayStyle) ? '' : this.props.displayStyle;
      var background = this.props.hideWhiteBackground ? "" : "background-white";
      var tableStyle = this.props.hideCardBorder ? "" : background + ' ' + (this.props.breakpoint < 3 ? "margin-bottom-12 pdp-tab-card-container-mobile padding-horizontal-16" : "pdp-tab-card-container" + (this.props.allowOverflow ? "-no-overflow" : "") + " padding-horizontal-" + (this.props.noPadding ? "0" : "30")) + ' ' + ((0, _ramda.isNil)(this.props.className) ? '' : this.props.className);
      var headerTitle = "";
      if (!(0, _ramda.isNil)(this.props.headerTitle)) {
        headerTitle = (0, _functional_utility.isNilOrEmpty)(this.props.headerTitle.key) ? this.props.headerTitle : _string_utility2.default.getLocalizedString(this.props.intl, this.props.headerTitle.props.defaultMessage, this.props.headerTitle.key);
      }

      var ariaLabelVal = (0, _functional_utility.isNilOrEmpty)(this.props.ariaLabel) ? 'Read more about ' + headerTitle : this.props.ariaLabel;

      return _react2.default.createElement(
        'div',
        {
          className: 'padding-left-0 padding-right-0 margin-bottom-' + (this.props.breakpoint < 3 ? '16' : '32') + ' ' + custPosition + ' ' + (this.props.hideCardForPrintView === true ? 'print-hide' : '') + ' ' + (this.props.isDisclosureAbsent ? 'no-disclosure-present' : ''),
          'data-testid': 'card-component-' + this.props.dataTest,
          id: 'card-component-' + this.props.dataTest },
        _react2.default.createElement(
          'div',
          {
            className: tableStyle + ' print-page-break',
            style: this.props.style || {} },
          this.renderCardHeader(),
          this.props.children,
          !(0, _functional_utility.isNilOrEmpty)(this.props.extraDisclosureText) && !(0, _functional_utility.isNilOrEmpty)(this.props.extraPlacementId) && _react2.default.createElement(_disclosure2.default, {
            disclosureText: this.props.extraDisclosureText,
            placementId: this.props.extraPlacementId,
            hideDisclosureinCardForPrintView: this.props.hideDisclosureinCardForPrintView,
            disclosureWidthOverride: this.props.disclosureWidthOverride,
            shouldAlwaysShowMore: true,
            is25PercentCard: this.props.is25PercentCard
          }),
          !(0, _functional_utility.isNilOrEmpty)(this.props.disclosureText) && _react2.default.createElement(_disclosure2.default, {
            disclosureText: this.props.disclosureText,
            disclosureAdditionalStyle: this.props.disclosureAdditionalStyle,
            placementId: this.props.placementId,
            hideDisclosureinCardForPrintView: this.props.hideDisclosureinCardForPrintView,
            disclosureWidthOverride: this.props.disclosureWidthOverride,
            shouldAlwaysShowMore: this.props.shouldAlwaysShowMore,
            alwaysShowFullDisclosure: this.props.alwaysShowFullDisclosure,
            is25PercentCard: this.props.is25PercentCard,
            arialabel: ariaLabelVal
          }),
          !(0, _functional_utility.isNilOrEmpty)(this.props.secondDisclosureText) && !(0, _functional_utility.isNilOrEmpty)(this.props.secondPlacementId) && _react2.default.createElement(_disclosure2.default, {
            disclosureText: this.props.secondDisclosureText,
            placementId: this.props.secondPlacementId,
            hideDisclosureinCardForPrintView: this.props.hideDisclosureinCardForPrintView,
            disclosureWidthOverride: this.props.disclosureWidthOverride,
            shouldAlwaysShowMore: this.props.shouldAlwaysShowMore,
            alwaysShowFullDisclosure: this.props.alwaysShowFullDisclosure,
            is25PercentCard: this.props.is25PercentCard,
            arialabel: ariaLabelVal
          }),
          !(0, _functional_utility.isNilOrEmpty)(this.props.thirdDisclosureText) && !(0, _functional_utility.isNilOrEmpty)(this.props.thirdPlacementId) && _react2.default.createElement(_disclosure2.default, {
            disclosureText: this.props.thirdDisclosureText,
            placementId: this.props.thirdPlacementId,
            hideDisclosureinCardForPrintView: this.props.hideDisclosureinCardForPrintView,
            disclosureWidthOverride: this.props.disclosureWidthOverride,
            shouldAlwaysShowMore: this.props.shouldAlwaysShowMore,
            alwaysShowFullDisclosure: this.props.alwaysShowFullDisclosure,
            is25PercentCard: this.props.is25PercentCard,
            arialabel: ariaLabelVal
          }),
          !(0, _functional_utility.isNilOrEmpty)(this.props.additionalDisclosures) && this.props.additionalDisclosures.map(function (disclosure) {
            return _react2.default.createElement(_disclosure2.default, {
              disclosureText: disclosure.text,
              placementId: disclosure.placementId,
              hideDisclosureinCardForPrintView: _this2.props.hideDisclosureinCardForPrintView,
              disclosureWidthOverride: _this2.props.disclosureWidthOverride,
              shouldAlwaysShowMore: _this2.props.shouldAlwaysShowMore,
              alwaysShowFullDisclosure: _this2.props.alwaysShowFullDisclosure,
              is25PercentCard: _this2.props.is25PercentCard,
              arialabel: ariaLabelVal
            });
          })
        )
      );
    }
  }]);

  return CardComponent;
}(_react2.default.PureComponent);

exports.default = CardComponent;